<div class="bg-color-base-2500 h-100vh">
    <grid-row class="justify-content-center align-content-center h-100">
        <grid-col col="4" mobile="11" ipad="8" class="text-align-center">
            <div class="font-600 font-size-32px color-base-2200 line-h-40 letter-spacing-3">
                {{"YourTicketisissued" | translate}}
            </div>
            <div class="font-400 font-size-16px color-base-2200 mt-30">
                {{"Pleasewaitforyouturn" | translate}}
            </div>
            <div class="font-400 font-size-16px color-base-2200 mt-5">
                {{"Yourticketnumberis" | translate}}
            </div>

            <div class="mt-30 ticket-num">
                <div class="img-box">
                    <img src="../../assets/images/union.png" alt="">
                </div>
                <div class="text-box" *ngIf="this.SkipQue == 'Skipque' && this.IssueTicket != undefined">
                    {{this.IssueTicket.ticketNumber}}
                </div>
                <div class="text-box" *ngIf="this.SkipQue == 'CheckStatus' && this.CheckVstStatus != undefined">
                    {{this.CheckVstStatus.ticketId}}
                </div>
            </div>

            <div class="border border-color-900 bg-base-100 p-16 br-12 box-shadow mt-30">
                <grid-row class="justify-content-between align-item-center border-bottom border-color-2100 pb-15">
                    <grid-col col="auto">
                        <div class="color-base-1300 font-size-14px font-500"
                            *ngIf="this.SkipQue == 'Skipque' && this.IssueTicket != undefined">
                            <!-- Seef Muharraq Mall -->{{this.BranchName}}
                        </div>
                        <div class="color-base-1300 font-size-14px font-500"
                            *ngIf="this.SkipQue == 'CheckStatus' && this.CheckVstStatus != undefined">
                            <!-- Seef Muharraq Mall -->{{this.CheckVstStatus.branchName}}
                        </div>

                    </grid-col>
                    <grid-col col="auto" *ngIf="this.SkipQue == 'Skipque'">
                        <span class="font-400 br-40 color-base-100 font-size-11px bg-primary pt-5 pb-5 pr-10 pl-10"
                            *ngIf="this.branchOpen == true"> {{"open" | translate}}
                        </span>
                        <span class="font-400 br-40 color-base-100 font-size-11px bg-primary pt-5 pb-5 pr-10 pl-10"
                            *ngIf="this.branchOpen == false"> {{"close" | translate}}</span>

                    </grid-col>
                    <grid-col col="auto" *ngIf="this.SkipQue == 'CheckStatus'">

                        <span class="font-400 br-40 color-base-100 font-size-11px bg-primary pt-5 pb-5 pr-10 pl-10"
                        *ngIf="this.Branchdetail[0].branchOpen == 'true'"> {{"open" | translate}}
                        </span>
                        <span class="font-400 br-40 color-base-100 font-size-11px bg-primary pt-5 pb-5 pr-10 pl-10"
                        *ngIf="this.Branchdetail[0].branchOpen == 'false'"> {{"close" | translate}}
                        </span>
<!-- 
                        <button class="btn-dft green" *ngIf="this.Branchdetail[0].branchOpen == 'true'">
                            {{"open" | translate}}
                        </button>
                        <button class="btn-dft green" *ngIf="this.Branchdetail[0].branchOpen == 'false'">
                            {{"close" | translate}}
                        </button> -->
                    </grid-col>
                </grid-row>
                <div class="color-primary font-size-14px font-500 mt-15 text-align-left"
                    *ngIf="this.SkipQue == 'Skipque'">
                    {{this.Cuswait}} <span>{{ "CustInQue" | translate}}</span>
                </div>
                <div class="color-primary font-size-14px font-500 mt-15 text-align-left"
                    *ngIf="this.SkipQue == 'CheckStatus'">
                    {{this.CheckVstStatus.queueSize}} <span>{{ "CustInQue" | translate}}</span>
                </div>
                <div class="color-base-500 font-size-12px font-400 mt-10 text-align-left"
                    *ngIf="this.SkipQue == 'Skipque'">
                    {{"Theestimatedwaiting" | translate}} <span>{{this.estimatedWaitTime}}</span>
                </div>
                <div class="color-base-500 font-size-12px font-400 mt-10 text-align-left"
                    *ngIf="this.SkipQue == 'CheckStatus'">
                    <!-- {{"Theestimatedwaiting" | translate}} <span>{{this.estimatedWaitTime}}</span> -->
                </div>
            </div>

            <grid-row class="mt-30">
                <grid-col col="12">
                    <button class="btn-dft-border" [routerLink]="['/Dashboard']">
                        {{ "BACKTODASHBOARD" | translate }}
                    </button>
                    <button class="btn-dft text-btn  mt-15" (click)="showModal(1)" *ngIf="this.SkipQue == 'Skipque'">
                        {{ "CancelTicket" | translate }}
                    </button>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>

<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="YES"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="Delete()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-remove-modal" width="72" height="72"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "Areyousureto" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-base-500 p-10">
            {{ "Pleaselogintoexperience" | translate }}
        </div>
    </div>
</modal>